(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/slice', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/slice'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.slice, global.convert);
    global.slice = mod.exports;
  }
})(this, function (exports, _slice2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.slice = undefined;

  var _slice3 = _interopRequireDefault(_slice2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces an array by a slice of the former array from <code>start</code> up to, but not including, <code>end</code>.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {number} [start=0] The start position.
   * @param {number} [end=array.length] The end position.
   * @return {Object} Returns the updated object.
   * @example slice({ nested: { prop: [1, 2, 3, 4] } }, 'nested.prop', 1, 3) // => { nested: { prop: [2, 3] } }
   * @see {@link https://lodash.com/docs#slice|lodash.slice} for more information.
   * @since 0.3.0
   */
  var slice = (0, _convert.convert)(_slice3.default);
  exports.slice = slice;
  exports.default = slice;
});